// 展开文案
export const spreadOut = 'AccountPage.ProfilePage.operatePermissionTree.spreadOut';
// 收起文案
export const collapse = 'AccountPage.ProfilePage.operatePermissionTree.collapse';

// 无权限文案
export const noPermissionMessage = 'AccountPage.ProfilePage.operatePermissionTree.noPermissionMessage';
